import { chestFurnitureLegs } from './legs/chestFurnitureLegs';
import { bedLegs } from './legs/bedLegs';
import { Legs } from './legs/legs';
import { tableLegs } from './legs/tableLegs';
import { coffeeTableLegs } from './legs/coffeeTableLegs';
import { bedsideTableLegs } from './legs/bedsideTableLegs';
import { deskLegs } from './legs/deskLegs';
import { coffeeTableRectangleLegs } from './legs/coffeeTableRectangleLegs';
import { dressingLegs } from './legs/dressingLegs';

export const legs: Legs[] = [];
legs.push(...chestFurnitureLegs);
legs.push(...bedLegs);
legs.push(...tableLegs);
legs.push(...coffeeTableLegs);
legs.push(...bedsideTableLegs);
legs.push(...deskLegs);
legs.push(...coffeeTableRectangleLegs);
legs.push(...dressingLegs);
